
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Ertigaonrentinpune() {



  const cardData =
  {
    keyword: ' Ertiga On Rent in Pune',
    heading: 'Vaishnavi Travels: Ertiga On Rent in Pune',
    headingDescription: 'Vaishnavi Travels provides reliable and budget-friendly Ertiga on Rent in Pune, ideal for family trips, weddings, corporate travel, airport transfers, and outstation journeys. Our Maruti Ertiga cars are well-maintained with spacious seating, strong air-conditioning, and ample luggage space, ensuring a smooth and comfortable ride for every passenger. With professional chauffeurs, timely pickups, and flexible booking options, we make travel convenient and stress-free. Whether it’s a local ride, weekend getaway, or long-distance tour, Vaishnavi Travels guarantees safe, comfortable, and affordable Ertiga rental services in Pune.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s grand fort palace and a symbol of Maratha pride. Its mighty gates, fountains, and sprawling courtyards once served as the political seat of the Maratha Empire. Though partially destroyed by fire in 1828, its ruins still captivate history lovers. The evening light-and-sound show revives the tales of Bajirao and Mastani. Tourists enjoy exploring its hidden pathways and gardens. Shaniwar Wada is Pune’s proud cultural crown."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a historic monument associated with India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. Today, it houses a museum preserving Gandhi’s belongings, letters, and photos. Its Italian arches and landscaped gardens make it a peaceful retreat. Students and tourists visit to connect with patriotism and heritage. Aga Khan Palace is Pune’s inspirational landmark of sacrifice."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, perched atop a hill 25 km from Pune, is famous for the 1670 battle fought by Tanaji Malusare for Chhatrapati Shivaji Maharaj. Trekkers climb its rugged paths for panoramic Sahyadri views. The fort still houses bastions, gates, and memorials of Maratha valor. During monsoon, mist and waterfalls add scenic charm. Local villagers serve rustic pithla-bhakri to visitors. Sinhagad Fort is Pune’s mix of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. Established over 125 years ago, the temple features a grand idol decorated with gold and ornaments. During Ganesh Chaturthi, it becomes the center of grand festivities attracting lakhs of devotees. Known for its charitable work, it blends devotion with social service. The temple’s aura is spiritually uplifting for all. Dagdusheth Temple is Pune’s divine heart of faith."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. Its massive stone pillars, sanctum, and Nandi mandapa showcase ancient craftsmanship. Despite being located in the city center, it offers a calm and spiritual retreat. Evening chants and prayers add mystical vibes. History enthusiasts admire its architectural simplicity. Pataleshwar is Pune’s hidden spiritual gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s cultural richness. Exhibits include ornaments, sculptures, weapons, and musical instruments. The recreated Mastani Mahal is a highlight for history enthusiasts. Students find it highly educational and inspiring. The museum preserves centuries of artistry under one roof. It is Pune’s proud showcase of tradition and culture."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers a panoramic view of the city from its summit. At the top stands the Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Smaller shrines and a museum nearby add to the heritage feel. Pilgrims climb 103 steps to reach the temple, blending devotion with scenic beauty. Sunrises and sunsets here are breathtaking. Parvati Hill is Pune’s sacred and serene retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global hub for wellness and spirituality. Spread across lush gardens, it attracts seekers from around the world. Meditation sessions, yoga practices, and workshops on personal growth are conducted daily. Its Zen gardens and serene halls create a rejuvenating environment. Beyond spirituality, it is also a wellness retreat for modern lifestyles. Osho Ashram is Pune’s international center of peace and mindfulness."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, bridges, and manicured lawns. Families love visiting for photography, picnics, and evening walks. Seasonal flowers and greenery add vibrant charm throughout the year. It also symbolizes Indo-Japanese friendship. Pu La Deshpande Garden is Pune’s green paradise of tranquility."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend retreat near Pune. It supplies water to the city while offering scenic hill views and flowing waters. In monsoon, the overflowing dam creates a mesmerizing sight. Families enjoy roasted corn and tea at roadside stalls nearby. It also serves as the gateway to Sinhagad Fort treks. Khadakwasla Dam is Pune’s refreshing natural escape."
  }
],


   "services": [
    {
      "name": "Ertiga Rental Pune",
      "description": "Experience the perfect blend of comfort, style, and practicality with our Ertiga rental service in Pune. Whether you need a spacious vehicle for city travel or a weekend getaway, our Ertigas offer ample seating and luggage space to accommodate families and groups effortlessly. All vehicles are regularly maintained and come with professional drivers who ensure your journey is safe, smooth, and enjoyable. Enjoy competitive pricing, flexible rental durations, and hassle-free booking options tailored to suit your travel needs."
    },
    {
      "name": "MPV Ertiga Hire Pune",
      "description": "Hire a Multi-Purpose Vehicle (MPV) like the Ertiga in Pune to meet your versatile transportation needs. Ideal for family outings, group trips, and business travels, the Ertiga MPV combines spacious interiors with advanced features for a comfortable ride. Our fleet includes well-maintained models with experienced drivers who understand Pune’s roads and traffic patterns, ensuring punctual and stress-free journeys. Benefit from customizable packages including hourly rentals, day hires, and long-term bookings to best fit your schedule."
    },
    {
      "name": "AC Ertiga Booking",
      "description": "Travel in cool comfort with our air-conditioned Ertiga booking service in Pune. Perfect for hot summer days or long drives, these AC-equipped vehicles provide a refreshing atmosphere to keep you relaxed throughout your trip. Our AC Ertiga cabs come with plush interiors, smooth suspension, and courteous drivers who prioritize your convenience and safety. Whether it's airport transfers, city tours, or outstation journeys, enjoy premium comfort without breaking the bank with our flexible booking options."
    },
    {
      "name": "Non AC Ertiga Car Rental",
      "description": "For those looking for an economical yet spacious ride, our non-AC Ertiga car rental service in Pune offers a practical alternative without compromising on comfort. Ideal for budget-conscious travelers, group outings, or short city rides, these vehicles provide ample seating and luggage space. All cars are regularly serviced and driven by professional chauffeurs who ensure safe and reliable travel. Take advantage of competitive rates and convenient rental terms suited to your exact needs."
    },
    {
      "name": "Family Ertiga Hire",
      "description": "Make family trips more enjoyable with our dedicated family Ertiga hire service in Pune. Designed to comfortably accommodate parents, kids, and elders alike, these spacious vehicles feature ample legroom, safety features, and storage space for luggage and essentials. Our courteous drivers are trained to provide a smooth, safe ride and assist with any family travel needs. Whether it’s a day outing, weekend vacation, or festival travel, our family Ertiga rentals ensure convenience, comfort, and peace of mind for every member."
    },
    {
      "name": "Wedding Ertiga Pune",
      "description": "Celebrate your special day with style and elegance by booking our wedding Ertiga service in Pune. These well-maintained vehicles are perfect for transporting the bride, groom, and close family members to and from wedding venues. Our professional chauffeurs ensure punctuality, smooth driving, and a comfortable ride amidst the celebrations. Customize your wedding car experience with decorative options, timely pickups, and flexible rental durations tailored to your event schedule, making your big day hassle-free and memorable."
    },
    {
      "name": "Outstation Ertiga Rental",
      "description": "Planning a long-distance trip? Our outstation Ertiga rental service in Pune is ideal for comfortable and safe travel to neighboring cities and hill stations. Equipped with spacious interiors, air conditioning options, and experienced drivers familiar with highways and routes, our Ertiga cars ensure a relaxing journey. Enjoy flexibility in trip duration, transparent pricing, and easy online booking. Whether it’s a business trip, family vacation, or weekend getaway, our outstation rentals prioritize your comfort and timely arrivals."
    },
    {
      "name": "Corporate Ertiga Service",
      "description": "Professional, reliable, and comfortable — our corporate Ertiga service in Pune is designed to cater to business travelers and company needs. Whether it’s employee transportation, client pickups, or business meetings across the city or outstation, our fleet of well-maintained Ertigas paired with professional drivers offer a seamless travel experience. Enjoy punctual pickups, clean and well-equipped vehicles, and the convenience of flexible billing and long-term corporate contracts customized to your organizational requirements."
    },
    {
      "name": "7 Seater Ertiga Hire",
      "description": "Travel together with your group or family in our spacious 7 seater Ertiga rental service in Pune. Designed to comfortably seat seven passengers with adequate luggage space, this vehicle is perfect for trips requiring extra capacity without sacrificing comfort. Our Ertigas are equipped with safety features, air conditioning, and plush seating, driven by professional chauffeurs who ensure smooth rides. Book with ease for airport transfers, sightseeing tours, or long-distance travel with guaranteed satisfaction."
    },
    {
      "name": "Ertiga with Driver Pune",
      "description": "Enjoy stress-free travel around Pune by hiring an Ertiga with a professional driver. Our experienced chauffeurs are well-trained in customer service, safe driving, and route knowledge to make your journey smooth and punctual. Whether it’s daily commuting, special events, or outstation trips, renting an Ertiga with a driver provides convenience, flexibility, and safety. Benefit from customizable rental durations and competitive pricing designed to suit both short-term and extended use."
    },
    {
      "name": "Budget Ertiga Rental",
      "description": "Get the best value for your money with our budget Ertiga rental options in Pune. Perfect for travelers looking for affordable yet comfortable transportation, these rentals provide ample seating and luggage capacity without extra frills. All vehicles undergo regular maintenance and are driven by professional drivers who prioritize safety and timely service. Whether for city rides or short trips, enjoy competitive pricing, transparent fare structures, and hassle-free bookings tailored to your budget."
    },
    {
      "name": "One Way Ertiga Hire Pune",
      "description": "Our one-way Ertiga hire service in Pune offers flexibility for travelers who prefer different pick-up and drop-off locations without the need for round-trip charges. Ideal for airport drop-offs, one-way city transfers, or intercity travel, this service combines convenience with affordable pricing. Vehicles are clean, comfortable, and driven by courteous drivers who ensure timely arrivals and departures. Book your one-way Ertiga easily online and enjoy transparent fare options with no hidden costs."
    },
    {
      "name": "Book Ertiga Online Pune",
      "description": "Enjoy the convenience of booking your Ertiga rental online in Pune with our secure and user-friendly platform. Choose your preferred vehicle type, rental duration, and additional options with instant confirmation and 24/7 customer support. Our digital booking system makes planning your travel simple and efficient, whether you need a cab for city travel, outstation trips, or special occasions. Benefit from transparent pricing, flexible cancellation policies, and a fleet of well-maintained vehicles ready to serve you."
    }
  ],
  "tableData": [
    ["Ertiga Rental Pune", "MPV Ertiga Hire Pune"],
    ["AC Ertiga Booking", "Non AC Ertiga Car Rental"],
    ["Family Ertiga Hire", "Wedding Ertiga Pune"],
    ["Outstation Ertiga Rental", "Corporate Ertiga Service"],
    ["7 Seater Ertiga Hire", "Ertiga with Driver Pune"],
    ["Budget Ertiga Rental", "One Way Ertiga Hire Pune"],
    ["Book Ertiga Online Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Ertiga on Rent in Pune",
    "WhyChoosedescription": "Vaishnavi Travels offers comfortable and reliable Ertiga rentals in Pune, perfect for family trips, group outings, and corporate travel."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Ride",
    "WhyChoosedescription": "The Ertiga provides ample space for up to 6 passengers, ensuring a comfortable journey for all."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Our Ertiga vehicles are regularly serviced and thoroughly cleaned to ensure safety and hygiene throughout your journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with the Route",
    "WhyChoosedescription": "Our professional drivers know the best routes in and around Pune, ensuring a smooth and timely travel experience."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "We offer competitive pricing with no hidden charges, ensuring value for your money."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Locations",
    "WhyChoosedescription": "Enjoy convenient door-to-door service from your home, hotel, or office in Pune."
  },
  {
    "WhyChooseheading": "Ideal for Leisure and Group Trips",
    "WhyChoosedescription": "Perfect for families, friends, and corporate groups looking to explore Pune and nearby destinations."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
    "WhyChoosedescription": "Our support team is available round-the-clock to assist you with bookings, itinerary planning, and travel inquiries."
  }
]


















  }




const faqData = [
  [
    {
      question: 'What is the daily rental rate for an Ertiga in Pune?',
      answer: 'Daily self‑drive rents for Ertiga generally start around **₹3,199/day**. :contentReference[oaicite:0]{index=0}',
    },
    {
      question: 'Is there a local (city) package for Ertiga in Pune?',
      answer: 'Yes — for example, 8 hours / 80 km local package rates are ~ **₹2,700‑₹2,800** for Ertiga. :contentReference[oaicite:1]{index=1}',
    },
    {
      question: 'What is the rate per km for outstation or longer trips with Ertiga?',
      answer: 'Outstation / extra km rates typically are ~ **₹14‑₹16/km** depending on the operator and distance. :contentReference[oaicite:2]{index=2}',
    },
    {
      question: 'Are driver, fuel, tolls included in the Ertiga rental fare?',
      answer: 'No — driver, tolls, parking, and sometimes extra charges like “night halt” or driver allowance are typically extra. Always check with the rental provider. :contentReference[oaicite:3]{index=3}',
    },
    {
      question: 'What is the minimum km limit or daily mileage included?',
      answer: 'Packages often include ~300 km/day for outstation or full‑day rentals. Exceeding that limit will incur extra per‑km charges. :contentReference[oaicite:4]{index=4}',
    },
    {
      question: 'Is a security deposit needed for renting an Ertiga in Pune?',
      answer: 'Yes — many providers ask for a refundable security deposit, which can vary (often a few thousand rupees). :contentReference[oaicite:5]{index=5}',
    },
    {
      question: 'What documents are required to rent an Ertiga?',
      answer: 'Typically valid driver’s license, government ID (Aadhar, Passport, etc.) and sometimes address proof. Some providers also require you to meet age criteria. :contentReference[oaicite:6]{index=6}',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Rajesh Kulkarni",
    position: "Family Traveller",
    feedback: "We rented an Ertiga for a two‑day trip through Pune with a driver. The car was clean, roomy, and the extra km charges were clearly explained. Great experience overall!",
    rating: 5,
  },
  {
    name: "Ms. Priya Singh",
    position: "Self‑drive User",
    feedback: "Tried self‑drive Ertiga from Rentrip for a week. Booking was smooth, rates reasonable, and security deposit refunded without issues. Comfortable for both city drives and highway cruising.",
    rating: 4,
    style: "style-2",
  }
];













































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];

const ertigaSchema = {
  "@context": "https://schema.org",
  "@type": "VehicleRental",
  "name": "Ertiga On Rent in Pune",
  "description": "Rent a 7-seater Ertiga in Pune for family trips, weddings, corporate use, and outstation travel. AC and Non-AC Ertiga car rentals with driver available. Book online for affordable and reliable Ertiga hire.",
  "vehicle": {
    "@type": "Car",
    "name": "Maruti Suzuki Ertiga",
    "seatingCapacity": 7,
    "fuelType": "Petrol/Diesel"
  },
  "provider": {
    "@type": "LocalBusiness",
    "name": "Vaishnavi Travels",
    "telephone": "+91-9765685295",
    "url": "https://vaishnavitravel.com/ertiga-on-rent-pune"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://vaishnavitravel.com/ertiga-on-rent-pune",
    "availability": "https://schema.org/InStock",
    "priceCurrency": "INR"
  }
};





  return (
    <div>

<Helmet>
  <title>Ertiga On Rent in Pune | 7 Seater Car Rental with Driver</title>
  <meta
    name="description"
    content="Rent a 7-seater Ertiga in Pune for family trips, weddings, corporate use, and outstation travel. AC and Non-AC Ertiga car rentals with driver available. Book online for affordable and reliable Ertiga hire."
  />
  <meta
    name="keywords"
    content="Ertiga Rental Pune, MPV Ertiga Hire Pune, AC Ertiga Booking, Non AC Ertiga Car Rental, Family Ertiga Hire, Wedding Ertiga Pune, Outstation Ertiga Rental, Corporate Ertiga Service, 7 Seater Ertiga Hire, Ertiga with Driver Pune, Budget Ertiga Rental, One Way Ertiga Hire Pune, Book Ertiga Online Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(ertigaSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/62.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ertigaonrentinpune;